import React from "react";
import { Modal, Button } from "react-bootstrap";
import moment from "moment";

const VehicleDetailModal = ({ show, onHide, vehicle }) => {
  if (!vehicle) return null;
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return moment(dateString).format("DD-MM-YYYY");
  };
  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Vehicle Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          <strong>Number Plate : </strong> {vehicle.numberplate}
        </p>
        <p>
          <strong>Chassis Number : </strong> {vehicle.chassisnumber}
        </p>
        <p>
          <strong>Battery Percentage : </strong> {vehicle.battery_percentage}
        </p>
        <p>
          <strong>GPS Status : </strong> {vehicle.gpsstatus ? "True" : "False"}
        </p>
        <p>
          <strong>Vehicle Type : </strong>{" "}
          {vehicle.id_type ? vehicle.id_type.vehiclename : "N/A"}
        </p>
        <p>
          <strong>Vehicle Feet : </strong>{" "}
          {vehicle.id_type ? vehicle.id_type.feet : "-"}
        </p>
        <p>
          <strong>Vehicle Company : </strong>{" "}
          {vehicle.id_type ? vehicle.id_type.company : "N/A"}
        </p>
        <p>
          <strong>Leasing Partner : </strong>{" "}
          {vehicle.leaseInfo ? vehicle.leaseInfo.leasing_partner : "N/A"}
        </p>
        <p>
          <strong>Wheeler Type : </strong>{" "}
          {vehicle.id_type ? vehicle.id_type.vehicle_type : "N/A"}
        </p>
        {/* <p>
          <strong>Vehicle Category:</strong>{" "}
          {vehicle.vehicleCategory ? vehicle.vehicleCategory : "N/A"}
        </p> */}
        <p>
          <strong>Driver Name : </strong>
          {vehicle.id_driver && vehicle.id_driver.length > 0 ? (
            vehicle.id_driver.map((driver, index) => (
              <div key={driver._id}>
                <span>
                  Driver {index + 1} - {driver.id_user?.name}
                </span>
                {driver.phonenumber && <span>, {driver.phonenumber}</span>}
              </div>
            ))
          ) : (
            <span> N/A</span>
          )}
        </p>
        <p>
          <strong>Current Driver : </strong>
          <span style={{ whiteSpace: "nowrap", overflow: "visible" }}>
            {vehicle.current_driver?.id_user?.name ||
              vehicle.id_adhocUser?.name ||
              "-"}
          </span>
        </p>

        <p>
          <strong>Last Driver : </strong>
          <span style={{ whiteSpace: "nowrap", overflow: "visible" }}>
            {vehicle.last_driver?.id_user?.name || "-"}
          </span>
        </p>

        <p>
          <strong>Hub Name : </strong>
          {Array.isArray(vehicle.id_hub) && vehicle.id_hub.length > 0 ? (
            vehicle.id_hub.map((hub, index) => (
              <div key={hub._id}>
                <span>
                  Hubs {index + 1} - {hub.name}
                </span>
              </div>
            ))
          ) : (
            <span> N/A</span>
          )}
        </p>
        <p>
          <strong>Model : </strong> {vehicle.model}
        </p>
        <p>
          <strong>Year : </strong> {vehicle.year}
        </p>
        <p>
          <strong>Color : </strong> {vehicle.color}
        </p>

        <p>
          <strong>Assigned Location:</strong>
          {Array.isArray(vehicle.assignedlocation) &&
          vehicle.assignedlocation.length > 0 ? (
            <ol className="mt-2 ps-3">
              {vehicle.assignedlocation
                .flatMap((loc) => {
                  try {
                    const parsed = JSON.parse(loc);
                    return Array.isArray(parsed) ? parsed : [parsed];
                  } catch {
                    return [loc];
                  }
                })
                .map((location, index) => (
                  <li key={index}>{location}</li>
                ))}
            </ol>
          ) : (
            <p>-</p>
          )}
        </p>
        {/* <p>
          <strong>Location : </strong> {vehicle.assignedlocation}
        </p> */}
        {/* <p>
          <strong>Coordinates : </strong>{" "}
          {vehicle.coordinates ? (
            <>
              <span>
                <strong>Latitude : </strong> {vehicle.coordinates.latitude}
              </span>
              <span>, </span>
              <span>
                <strong>Longitude : </strong> {vehicle.coordinates.longitude}
              </span>
            </>
          ) : (
            <span>N/A</span>
          )}
        </p> */}

        <p>
          <strong>Vendor Name : </strong>{" "}
          {vehicle.id_vendor ? vehicle.id_vendor?.id_user?.name : "N/A"}
        </p>
        <p>
          <strong>Total KM : </strong> {vehicle.totalkm}
        </p>
        <p>
          <strong>Capacity : </strong> {vehicle.capacity}
        </p>
        <p>
          <strong>Lease : </strong> {vehicle.lease}
        </p>
        <p>
          <strong>Length : </strong> {vehicle.length}
        </p>
        <p>
          <strong>Status : </strong> {vehicle.status}
        </p>
        <p>
          <strong>On-Boarding Date : </strong>{" "}
          {formatDate(vehicle.onBoardingDate)}
        </p>
        <p>
          <strong>Comments : </strong> {vehicle.comments}
        </p>
        <p>
          <strong>Created By : </strong>{" "}
          {vehicle.createdBy && (
            <>
              <span>
                <strong>Name:</strong> {vehicle.createdBy.user_email}
              </span>
              <span>, </span>
              <span>
                <strong>Role:</strong> {vehicle.createdBy.user_role}
              </span>
            </>
          )}
        </p>
        <p>
          <strong>Created Date : </strong>{" "}
          {vehicle.createdAt && (
            <>{new Date(vehicle.createdAt).toLocaleDateString()}</>
          )}
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default VehicleDetailModal;
